import React from 'react';
import { useLocation } from 'react-router-dom';
import { homeForRole } from '../route/RoleRoute';

const storedRole = () => {
    try {
        const u = JSON.parse(localStorage.getItem('admin') || localStorage.getItem('doctor') || localStorage.getItem('hr') || '{}');
        return u && u.role;
    } catch (e) {
        return undefined;
    }
};

// App-wide last line of defence: a render error shows a message with Reload instead of a white page.
class Boundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('Page failed to render:', error, info?.componentStack);
    }

    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({ error: null });
    }

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
                <div className="card shadow-sm p-4 text-center" style={{ maxWidth: 480 }}>
                    <h5 className="mb-2">Something went wrong loading this page.</h5>
                    <p className="text-muted mb-3">Please reload. If it keeps happening, contact support.</p>
                    <div>
                        <button type="button" className="btn btn-primary mr-2 me-2" onClick={() => window.location.reload()}>Reload page</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => window.location.assign(homeForRole(storedRole()))}>Go to my dashboard</button>
                    </div>
                </div>
            </div>
        );
    }
}

const AppErrorBoundary = ({ children }) => {
    const { pathname } = useLocation();
    return <Boundary resetKey={pathname}>{children}</Boundary>;
};

export default AppErrorBoundary;
